import React from 'react';
import { useTranslation, useEnvironment } from '@wix/yoshi-flow-editor';

// UI
import { ProgressBar } from '@wix/wix-ui-tpa/cssVars';
import { Box, type IBoxProps } from 'wui/Box';
import { Typography } from 'wui/Typography';

// types
import { type Step } from '@wix/ambassador-groups-onboarding-v1-onboarding/types';

import classes from './OnboardingProgress.scss';

type ProgressProps = {
  steps: Step[];
};

export function OnboardingProgress(props: ProgressProps & IBoxProps) {
  const { steps, ...rest } = props;

  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { label, progress } = getCompletedSteps(steps);
  return (
    <Box paddingLeft={20} paddingRight={20} paddingBottom={12} {...rest}>
      <ProgressBar
        value={progress}
        prefixIndication={
          isMobile ? undefined : (
            <Typography className={classes.label} variant="p2-12" noWrap>
              {label}
            </Typography>
          )
        }
      />
    </Box>
  );

  function getCompletedSteps(
    steps: Step[] = [],
    unit: string = t('groups-web.onboarding.steps.unit'),
  ) {
    const completedSteps = steps.filter((step) => step.status === 'COMPLETED');
    const label = `${completedSteps.length}/${steps.length} ${unit}`;
    const progress = (completedSteps.length / steps.length) * 100;
    return {
      label,
      progress,
    };
  }
}

OnboardingProgress.displayName = 'OnboardingProgress';
